import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import ReactSelectMaterial from '../../components/ReactSelectMaterial/ReactSelectMaterial';
import ActionButton from '../../components/ActionButton/ActionButton';
import DialogComponent from '../../components/DialogComponent/DialogComponent';
import { isObjectValidAndNotEmpty } from '../../constants/nullCheckUtils';
import { isValidTextAndNotEmpty } from '../../constants/CommonUtil';

import fetchPartnerDto from './PartnerSelectUtil';
import { displayWarning } from '../../redux/modules/warningDialog/warningDialog-actions';
import api from '../../constants/api';

class PartnerSelectionComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            payer: null,
            subInsurer: null,
        };
    }

    onSubmitPartner = () => {
        const { payer, subInsurer } = this.state;
        const { onPartnerChange, onClose, dispatch } = this.props;
        const partner = isObjectValidAndNotEmpty(subInsurer) ? subInsurer : payer;
        if (isObjectValidAndNotEmpty(partner)) {
            fetchPartnerDto(partner, dispatch).then(onPartnerChange);
        }
        onClose();
    };


    onChangeField = fieldName => (value) => {
        const { subInsurer } = this.state;
        const { dispatch } = this.props;
        const isPayer = fieldName === 'payer';

        const changeValues = () => {
            this.setState({
                [fieldName]: value,
                ...(isPayer ? { subInsurer: null } : {}),
            });
        };

        if (isPayer) {
            if (!isObjectValidAndNotEmpty(subInsurer)) {
                changeValues();
                return;
            }
            dispatch(displayWarning(
                'Any unsaved data will be cleared. Do you really want to change the TPA?',
                changeValues,
            ));
        } else {
            if (!value || !isValidTextAndNotEmpty(value.key)) {
                this.setState({ subInsurer: null });
                return;
            }
            changeValues();
        }
    };


    render() {
        const {
            payer,
            subInsurer,
        } = this.state;

        const {
            open, onClose, header,
        } = this.props;

        return (
            <DialogComponent
                header={header}
                maxWidth="md"
                open={open}
                handleClose={onClose}
            >
                <Grid container className="mt-1" justify="flex-start">
                    <Grid item lg={5} md={4} sm={4}>
                        <ReactSelectMaterial
                            dataSourceApi={`${api.SEARCH.INSURANCE_PAYERS_BY_TYPE}?payerType=INSURANCE&onlyActive=true&searchString=`}
                            dataSourceConfig={{
                                value: 'key',
                                text: 'value',
                            }}
                            label="TPA"
                            autoFocus
                            autocomplete
                            onChange={this.onChangeField('payer')}
                            value={payer}
                        />
                    </Grid>

                    {isObjectValidAndNotEmpty(payer) && (
                        <Grid className="ml-1" item sm={4} md={4} lg={5}>
                            <ReactSelectMaterial
                                dataSourceApi={`${api.SEARCH.INSURANCE_PAYERS_BY_TYPE}?parentUuid=${payer.key}&payerType=SUBINSURANCE&onlyActive=true&searchString=`}
                                dataSourceConfig={{
                                    value: 'key',
                                    text: 'value',
                                }}
                                label="Sub Insurer"
                                onChange={this.onChangeField('subInsurer')}
                                disabled={!isObjectValidAndNotEmpty(payer)}
                                value={subInsurer}
                            />
                        </Grid>
                    )}
                </Grid>
                <Grid container justify="flex-end" className="mt-2">
                    <Grid item>
                        <ActionButton
                            disabled={
                                !(
                                    isObjectValidAndNotEmpty(subInsurer) ||
                                    isObjectValidAndNotEmpty(payer)
                                )
                            }
                            onClick={this.onSubmitPartner}
                        >
                            Submit
                        </ActionButton>
                    </Grid>

                    <Grid item style={{ marginLeft: 8 }}>
                        <ActionButton onClick={onClose}>
                            Cancel
                        </ActionButton>
                    </Grid>
                </Grid>
            </DialogComponent>
        );
    }
}

PartnerSelectionComponent.propTypes = {
    header: PropTypes.string,
    onClose: PropTypes.func,
    onPartnerChange: PropTypes.func,
    dispatch: PropTypes.func,
    open: PropTypes.bool.isRequired,
};


PartnerSelectionComponent.defaultProps = {
    header: '',
    onClose: () => {},
    onPartnerChange: () => {},
    dispatch: () => {},
};

export default PartnerSelectionComponent;
